var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var $ = require("./lib/qsa");

// Global vars
var quiz = null;
var results = null;
var pymChild = null;

var numTaken = 0;
var numCorrect = 0;
var numWrong = 0
var numRemaining = 0;
var promptsRight = [];
var promptsWrong = [];
var promptsPartial = [];

console.clear();

/*
 * Initialize the graphic.
 */
var onWindowLoaded = function () {
  quiz = document.querySelector("#quiz");
  results = document.querySelector("#results");

  initNextQuestion(1);

  promptsRight = PROMPTS.filter(d => d.type == "right");
  promptsWrong = PROMPTS.filter(d => d.type == "wrong");
  promptsPartial = PROMPTS.filter(d => d.type == "partial");
 
  // social share toggle
  // if ("share" in navigator) {
  //   document.body.classList.add("navigator-share-supported");

  //   $.one(".navigator-share").addEventListener("click", function () {
  //     var shared = navigator.share({
  //       text: PROJECT_TEXT,
  //       url: PROJECT_LINK
  //     });

  //     ANALYTICS.trackEvent("clicked-social", "navigator");
  //   });
  // } else {
  //   var socialLinks = document.querySelectorAll(".social-link");
  //   socialLinks.forEach((link, i) => {
  //     link.addEventListener("click", onSocialLinkClicked);
  //   });
  // }

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

var onSocialLinkClicked = function (evt) {
  ANALYTICS.trackEvent(evt.target.dataset.track, evt.target.dataset.label);
}


/*
 * Quiz
 */
var clearCurrentQuestion = function (qNum) {
  var thisQuestion = quiz.querySelector(".question-wrapper[data-question='" + qNum + "']");
  thisQuestion.classList.remove("current");

  thisQuestion.querySelector(".question").classList.add("answered");

  var answers = thisQuestion.querySelectorAll("button");
  answers.forEach((a, i) => {
    a.removeEventListener("click", onAnswerClicked);
    a.disabled = true;
  });
}

var initNextQuestion = function (qNum) {
  var thisQuestion = quiz.querySelector(".question-wrapper[data-question='" + qNum + "']");
  thisQuestion.classList.add("active");
  thisQuestion.classList.add("current");

  var answers = thisQuestion.querySelectorAll("button");
  answers.forEach((a, i) => {
    a.disabled = false;
    a.addEventListener("click", onAnswerClicked);
  });
}

var onAnswerClicked = function (evt) {
  var thisAnswer = evt.target;
  var thisQuestion = evt.target.closest(".question");
  var thisQuestionNumber = Number(thisQuestion.parentNode.dataset.question);
  var resultsMsg = '';

  // register that this question has been answered
  clearCurrentQuestion(thisQuestionNumber);
  numTaken++;
  numRemaining = NUM_QUESTIONS - numTaken;

  // check if the user selected the correct answer
  console.log(thisAnswer.closest("li").classList.value.toLowerCase())
  var gotItRight = thisAnswer.closest("li").classList.value.toLowerCase() === "correct" ? true : false;

  var answerLabel = document.createElement("b");
  if (gotItRight) {
    numCorrect++;
    answerLabel.textContent = promptsRight[Math.floor(Math.random() * promptsRight.length)].message;
  } else if (thisAnswer.closest("li").classList.value.toLowerCase() === "partial" ? true : false) {
    numWrong++;
    answerLabel.textContent = promptsPartial[Math.floor(Math.random() * promptsPartial.length)].message;
  } else {
    numWrong++;
    answerLabel.textContent = promptsWrong[Math.floor(Math.random() * promptsWrong.length)].message;
  }
  thisAnswer.prepend(answerLabel);
  thisAnswer.closest("li").classList.add("selected");

  // if all questions have been answered, show a message relative to score
  if (numTaken == NUM_QUESTIONS) {
    results.classList.add("final");
    var resultsTopline = results.querySelector("#answered-correct");
    resultsTopline.innerHTML = numCorrect;

    if (numCorrect <= 4) {
      resultsMsg += FINAL_LOW;
    } else if (numCorrect >= 5 && numCorrect < 6) {
      resultsMsg += FINAL_MID;
    } else if (numCorrect >= 6) {
      resultsMsg += FINAL_HIGH;
    }

    var finalResults = results.querySelector("#final-results");
    finalResults.innerHTML = resultsMsg;

    ANALYTICS.trackEvent("questions-answered", NUM_QUESTIONS);

    // otherwise, go on to the next question
  } else {
    results.classList.add("active");
    var resultsMsgCounter = results.querySelector("#answered-count");
    resultsMsgCounter.innerHTML = numTaken;

    initNextQuestion(thisQuestionNumber + 1);

    ANALYTICS.trackEvent("questions-answered", numTaken);
  }

  // update the iframe height
  if (pymChild) {
    pymChild.sendHeight();
  }
}

/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.addEventListener("load", onWindowLoaded);